export default {
	name: 'monitoring-center-real-video',
	path: '/monitoring-center/real-video',
	component: () => import('./pages/real-video/real-video.vue')
};
